// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2nnI7","label":"SetPasswdForm_label__1AfW6"};